

import { Component, Vue, Prop} from 'vue-property-decorator';
import { Question } from "survey-vue";

@Component
export default class CustomButton extends Vue {
    
    @Prop({required: true})
    question!: Question
 
    textClass = "";   
    buttonText = "";
    buttonVariant = "";
    buttonType = "";
    hasSpinner = ""
    clickedNumber = 0;

    readOnly = false; 
    dataReady = false;

    mounted(){ 
      this.dataReady = false ;        
      this.textClass = this.question.textClass;        
      this.buttonText = this.question.buttonText;
      this.buttonVariant = this.question.variant;
      this.buttonType = this.question.buttonType;
      this.hasSpinner = this.question.spinner;
      this.readOnly = this.question.readOnly;
      this.dataReady = true
    }

    public inputChanged(){
      this.clickedNumber++;
      this.question.value = this.clickedNumber;
    }

}
